// src/styles/global.jsx
import { createGlobalStyle } from 'styled-components';
import { colors } from './colors';

export default createGlobalStyle`
    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-track {
        background: ${colors.surface};
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${colors.secondary};
        border-radius: 10px;
    }

    body {
        background-color: ${colors.background};
        color: ${colors.white};
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 14px;
    }

    input, textarea, select {
        background-color: ${colors.surface};
        color: ${colors.white};
        border: 1px solid ${colors.secondary};
        border-radius: 8px;
        padding: 8px 12px;
    }

    h1, h2, h3, h4 {
        color: ${colors.secondary};
        font-weight: bold;
    }

    button {
        transition: all 0.2s ease-in-out;
        font-size: inherit;
        font-family: inherit;
    }

    .form-box {
        background: ${colors.surface};
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 0 8px rgba(2, 234, 117, 0.2);
        border: 1px solid ${colors.secondary};
    }
`;
